import React, { lazy } from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo I — El Filtro Anti-Clava Vistos',
    subtitle: 'Consultas que convierten · Scripts de primera respuesta',
    desc: 'Dejaron de responderte al dar el precio. Con la Fórmula de Respuesta Triple y el Protocolo Anti-Visto, vas a integrar valor, precio y seña en un solo mensaje. Identificá en segundos quién va a reservar y rescatá conversaciones sin sonar desesperada.'
  }, {
    icon: '📗',
    title: 'Tomo II — La Psicología de la Seña',
    subtitle: 'Cómo cobrar el 50% por adelantado sin incomodidad',
    desc: 'Pedir el 50% por adelantado te incomoda. Aprendé a usar las 3 estructuras de seña y el momento exacto para pedirla sin generar resistencia. Incluye scripts copiables para las 10 objeciones más frecuentes y un protocolo de confirmación automático.'
  }, {
    icon: '📙',
    title: 'Tomo III — El Muro de Contención',
    subtitle: 'Políticas de cancelación y límites que sí se cumplen',
    desc: 'Las cancelaciones de último momento rompen tu agenda. Implementá políticas claras pre-reserva y el semáforo de excepciones. Llevate textos listos para WhatsApp e Instagram que comunican tus reglas con autoridad y respeto.'
  }, {
    icon: '📕',
    title: 'Tomo IV — El Sistema de Reactivación',
    subtitle: 'Cómo llenar huecos y recuperar clientas inactivas',
    desc: 'Los huecos vacíos te hacen perder plata. Activá el Protocolo de Llenado Exprés y la lista de espera para cubrir cancelaciones en minutos. Usá los 3 mensajes de reactivación para recuperar clientas y construí un sistema de referidos automático.'
  }];
  const includes = ['Explicación clara sin tecnicismos ni teoría de marketing', 'Protocolo paso a paso aplicable desde hoy mismo', 'Scripts, mensajes copiables y respuestas listas para usar', 'Tablas, trackers y checklists listos para completar', 'Ejemplos reales del rubro belleza en Argentina', 'Compatible con manicura, lashes, cejas, estética y cualquier servicio por turno', 'Diseño premium — listo para usar en celular o impreso'];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-280">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-281"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-282">
        <FadeIn data-id="element-283">
          <div className="text-center mb-16" data-id="element-284">
            <div className="inline-block bg-pink-500/10 text-pink-400 px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-pink-500/20 uppercase" data-id="element-285">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-4xl md:text-6xl text-white mb-4 tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-286">
              🏆 MÉTODO{' '}
              <span className="text-pink-400" data-id="element-287">TURNOS BLINDADOS™</span>
            </h2>
            <p className="text-lg md:text-xl font-sans font-medium opacity-90 text-[#FFFFFF]" data-id="element-288">
              4 Tomos + 4 Bonos · 100+ páginas · Todo resuelto.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-20" data-id="element-289">
            <div className="lg:col-span-7 space-y-5" data-id="element-290">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-900/30 hover:bg-navy-900/50 transition-colors p-6 md:p-8 rounded-3xl border border-white/5 relative overflow-hidden group" data-id="element-291">
                  <div className="absolute left-0 top-0 w-1 h-full bg-pink-500/20 group-hover:bg-pink-500/50 transition-colors" data-id="element-292"></div>
                  <div className="flex items-start gap-5 md:gap-6" data-id="element-293">
                    <span className="text-3xl md:text-4xl shrink-0 mt-1 drop-shadow-sm" data-id="element-294">
                      {tomo.icon}
                    </span>
                    <div data-id="element-295">
                      <h3 className="text-lg md:text-xl font-sans font-black text-white leading-tight mb-1.5" data-id="element-296">
                        {tomo.title}
                      </h3>
                      <p className="text-pink-400 text-xs md:text-sm font-bold uppercase tracking-wider mb-3 font-sans" data-id="element-297">
                        {tomo.subtitle}
                      </p>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed font-sans" data-id="element-298">
                        {tomo.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="lg:col-span-5 sticky top-24 hidden lg:block" data-id="element-299">
              <div className="relative w-full max-w-md mx-auto" data-id="element-300">
                <div className="absolute inset-0 bg-pink-500/10 blur-3xl rounded-full" data-id="element-301"></div>
                <img src="https://cdn.magicpatterns.com/uploads/fgmxGFmM7Kzxf4BZ5ZSeQJ/Mockup-Producto-4_(1).webp" alt="Método Turnos Blindados" className="relative z-10 w-full h-auto" width={400} height={400} loading="lazy" data-id="element-302" />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-303">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-pink-500/50 to-transparent" data-id="element-304" />
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full" data-id="element-305"></div>

            <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-12 font-[Montserrat,_sans-serif]" data-id="element-306">
              Cada Tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-307">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-4 bg-white/5 border border-white/5 p-5 rounded-2xl hover:bg-white/10 transition-colors" data-id="element-308">
                  <CheckCircle2 className="w-6 h-6 text-pink-400 flex-shrink-0" data-id="element-309" />
                  <span className="text-gray-100 font-medium text-sm md:text-base tracking-wide font-sans leading-snug" data-id="element-310">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};